import { render, staticRenderFns } from "./DeliveryIncomeByDay.vue?vue&type=template&id=6d1c945b&lang=pug&"
import script from "./DeliveryIncomeByDay.vue?vue&type=script&lang=ts&"
export * from "./DeliveryIncomeByDay.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryIncomeByDay.vue?vue&type=style&index=0&id=6d1c945b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports